/* eslint-disable */
import GraphQL from '../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AccountPlanQueryVariables = GraphQL.Exact<{
  accountId: GraphQL.Scalars['AccountId']['input'];
}>;


export type AccountPlanQuery = { readonly __typename?: 'Query', readonly account: { readonly __typename?: 'Account', readonly id: CK.AccountId, readonly plan: GraphQL.AccountPlan | null } | null };


export const AccountPlanDocument = gql`
    query AccountPlan($accountId: AccountId!) {
  account(id: $accountId) {
    id
    plan
  }
}
    `;

/**
 * __useAccountPlanQuery__
 *
 * To run a query within a React component, call `useAccountPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountPlanQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAccountPlanQuery(baseOptions: Apollo.QueryHookOptions<AccountPlanQuery, AccountPlanQueryVariables> & ({ variables: AccountPlanQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountPlanQuery, AccountPlanQueryVariables>(AccountPlanDocument, options);
      }
export function useAccountPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountPlanQuery, AccountPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountPlanQuery, AccountPlanQueryVariables>(AccountPlanDocument, options);
        }
export function useAccountPlanSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountPlanQuery, AccountPlanQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountPlanQuery, AccountPlanQueryVariables>(AccountPlanDocument, options);
        }
export type AccountPlanQueryHookResult = ReturnType<typeof useAccountPlanQuery>;
export type AccountPlanLazyQueryHookResult = ReturnType<typeof useAccountPlanLazyQuery>;
export type AccountPlanSuspenseQueryHookResult = ReturnType<typeof useAccountPlanSuspenseQuery>;
export type AccountPlanQueryResult = Apollo.QueryResult<AccountPlanQuery, AccountPlanQueryVariables>;